
<template>
  <div class="base-container">
    <navbar
      :routeGroupKey="routeGroupKey"
      @popFeedBack="showFeedBack = true"
      @closeFeedBack="showFeedBack = false"
    />
    <router-view v-show="!showFeedBack"></router-view>
    <feed-back v-if="showFeedBack" @submit="closeFeedBack"></feed-back>
    <div class="loading" v-if="loading">
      <Loading class="loading-circle"></Loading>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/navbar";
import Loading from "../components/loading";
import FeedBack from "./feedback";
import { getDict, bus } from "../common";

export default {
  props: ["routeGroupKey"],
  components: {
    Navbar,
    FeedBack,
    Loading,
  },
  data() {
    return {
      showFeedBack: false,
      loading: false,
    };
  },
  methods: {
    closeFeedBack() {
      this.showFeedBack = false;
      bus.$emit("feedBackClosed");
    },
  },
  created() {
    bus.$on("apiWaiting", () => {
      this.loading = true;
    });
    bus.$on("apiEndWait", () => {
      this.loading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.base-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 0;
}
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  .loading-circle {
    width: 1rem;
    height: 1rem;
  }
}
</style>
